import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hide } from 'store/modules/modal';
import format from 'date-fns/format';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import withStyles from '@material-ui/core/styles/withStyles';
import red from '@material-ui/core/colors/red';
import blue from '@material-ui/core/colors/blue';
import {
  activateCampaign,
  deleteCampaign,
} from 'routes/Dashboard/Home/modules';
import { randomInt } from 'helpers/utils';

export class CampaignInfoDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      active: this.props.campaign.active,
      status: 'none',
      numberBellow: randomInt(100, 999),
      typedNumber: '',
    };
  }

  render() {
    const { opened, campaign, dispatch, classes } = this.props;

    return (
      <div>
        <Dialog open={opened} onClose={() => dispatch(hide())}>
          <DialogTitle>{campaign.name}</DialogTitle>
          <DialogContent>
            {campaign.description && (
              <TextField
                margin="dense"
                id="description"
                label="Description"
                type="text"
                fullWidth
                multiline
                rowsMax={3}
                InputProps={{
                  disableUnderline: true,
                  readOnly: true,
                }}
                value={campaign.description}
              />
            )}
            <TextField
              margin="dense"
              id="brand"
              label="Brand"
              type="text"
              fullWidth
              InputProps={{
                disableUnderline: true,
                readOnly: true,
              }}
              value={campaign.brand}
            />
            <TextField
              margin="dense"
              id="mediaType"
              label="Media Type"
              type="text"
              fullWidth
              InputProps={{
                disableUnderline: true,
                readOnly: true,
              }}
              value={campaign.mediaType.join(', ')}
            />
            <TextField
              margin="dense"
              id="start"
              label="Start Date"
              type="text"
              fullWidth
              InputProps={{
                disableUnderline: true,
                readOnly: true,
              }}
              value={format(campaign.start, 'MMM D, YYYY')}
            />
            <TextField
              margin="dense"
              id="stop"
              label="Stop Date"
              type="text"
              fullWidth
              InputProps={{
                disableUnderline: true,
                readOnly: true,
              }}
              value={format(campaign.stop, 'MMM D, YYYY')}
            />
            {campaign.geography && (
              <TextField
                margin="dense"
                id="geography"
                label="Geography"
                type="text"
                fullWidth
                InputProps={{
                  disableUnderline: true,
                  readOnly: true,
                }}
                value={campaign.geography}
              />
            )}
            {campaign.value > 0 && (
              <TextField
                margin="dense"
                id="value"
                label="$ Value"
                type="text"
                fullWidth
                InputProps={{
                  disableUnderline: true,
                  readOnly: true,
                }}
                value={campaign.value.toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                })}
              />
            )}
            <FormGroup row>
              <FormControlLabel
                control={
                  <Switch
                    checked={this.state.active}
                    onChange={(event, checked) => {
                      this.setState({ active: checked });
                      dispatch(activateCampaign(campaign._id, checked));
                    }}
                    value="active"
                    color="primary"
                  />
                }
                label="Active"
              />
            </FormGroup>

            {this.state.status === 'deleting' && (
              <div className={classes.deleteContainer}>
                <div className={classes.deleteText}>
                  Please type the number bellow to delete the campaign
                </div>
                <div className={classes.numberBellow}>
                  {this.state.numberBellow}
                </div>
                <div className={classes.deleteInput}>
                  <TextField
                    placeholder="Type here"
                    type="number"
                    autoFocus
                    value={this.state.typedNumber}
                    name="typedNumber"
                    onChange={event => {
                      this.setState({ typedNumber: event.target.value });
                    }}
                  />
                </div>
                <div className={classes.buttonsContainer}>
                  <Button
                    className={classes.deleteButton}
                    size="small"
                    disabled={
                      this.state.numberBellow !==
                      parseInt(this.state.typedNumber, 10)
                    }
                    onClick={() => {
                      dispatch(deleteCampaign(campaign._id));
                      dispatch(hide());
                    }}
                  >
                    Delete
                  </Button>
                  <Button
                    size="small"
                    onClick={() => {
                      this.setState({
                        status: 'none',
                      });
                    }}
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            )}
          </DialogContent>
          <DialogActions className={classes.actions}>
            {this.state.status === 'deleting' && <div />}
            {this.state.status !== 'deleting' && (
              <Button
                variant="text"
                size="small"
                className={classes.deleteButton}
                onClick={() => {
                  this.setState({
                    status: 'deleting',
                    numberBellow: randomInt(100, 999),
                    typedNumber: '',
                  });
                }}
              >
                Delete campaign
              </Button>
            )}
            <Button onClick={() => dispatch(hide())} color="primary" autoFocus>
              close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    opened: state.modal.opened,
    message: ownProps.message,
  };
};

const styles = theme => ({
  deleteButton: {
    color: theme.palette.getContrastText(red[500]),
    backgroundColor: red[500],
    '&:hover': {
      backgroundColor: red[700],
    },
    marginRight: 20,
  },
  actions: {
    justifyContent: 'space-between',
  },
  deleteContainer: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#eee',
    marginTop: 10,
  },
  deleteText: {
    marginLeft: 20,
    paddingTop: 20,
    fontSize: '1em',
    fontWeight: 600,
    color: red[500],
  },
  numberBellow: {
    color: blue[700],
    marginLeft: 20,
    marginTop: 10,
    marginBottom: 10,
    fontSize: '1.2em',
    fontWeight: 700,
  },
  deleteInput: {
    marginLeft: 20,
  },
  buttonsContainer: {
    display: 'flex',
    marginLeft: 20,
    marginTop: 20,
    marginBottom: 20,
  },
});

export default withStyles(styles)(connect(mapStateToProps)(CampaignInfoDialog));
